import { matchVersion } from '../../utils';
import __regexp from './__android-regexp';
/** Detect the Android OS Version */
export default function isAndroidVersion(operator, version) {
	return function (ua) {
		return matchVersion({
			ua: ua,
			version: version,
			operator: operator,
			regExp: __regexp,
			groupIndex: 1
		});
	};
}
